/** Small labelled field wrapper used across BookingModal / InquiryModal. */
export default function MFld({ label, children }) {
  return (
    <label className="block">
      <span className="block text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-1.5">{label}</span>
      {children}
    </label>
  );
}
